import { render, staticRenderFns } from "./Copia_Assinatura.vue?vue&type=template&id=0a20776e&scoped=true&"
import script from "./Copia_Assinatura.vue?vue&type=script&lang=js&"
export * from "./Copia_Assinatura.vue?vue&type=script&lang=js&"
import style0 from "./Copia_Assinatura.vue?vue&type=style&index=0&id=0a20776e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a20776e",
  null
  
)

export default component.exports